var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-gray-600 hover:text-blue-500 flex items-center pr-1",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"uil uil-atom text-2xl pr-1"}),_c('span',{staticClass:"font-medium text-sm"},[_vm._v("Hera AI")])])
}
var staticRenderFns = []

export { render, staticRenderFns }